
import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';

export function* getMasterCoursesByCountry(countryCode) {
    const payload = yield call(api.getMasterCoursesByCountry, countryCode);
    if (payload.status === 200) {
        yield put(actions.getMasterCoursesByCountrySuccess(payload.data));
    } else {
        yield put(actions.getMasterCoursesByCountryFailure());
    }
}

export function* getMasterCoursesByCountrySaga() {
    yield takeLatest(actions.GET_MASTER_COURSES_BY_COUNTRY_REQUEST, getMasterCoursesByCountry);
}

export function* getCountriesWithMasterCourses() {
    const payload = yield call(api.getCountriesWithMasterCourses);
    if (payload.status === 200) {
        yield put(actions.getCountriesWithMasterCoursesSuccess(payload.data.map(country => ({
            value: country.name,
            key: country.code }))));
    } else {
        yield put(actions.getCountriesWithMasterCoursesFailure());
    }
}

export function* getCountriesWithMasterCoursesSaga() {
    yield takeLatest(actions.GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST, getCountriesWithMasterCourses);
}

export function* getSubjects() {
    const payload = yield call(api.getSubjects);
    if (payload.status === 200) {
        yield put(actions.getSubjectsSuccess(payload.data));
    } else {
        yield put(actions.getSubjectsFailure());
    }
}

export function* getSubjectsSaga() {
    yield takeLatest(actions.GET_SUBJECTS_REQUEST, getSubjects);
}

export function* getMasterCourses(accessStatus) {
    const payload = yield call(api.getMasterCourses, accessStatus);
    if (payload.status === 200) {
        yield put(actions.getMasterCoursesSuccess(payload.data));
    } else {
        yield put(actions.getMasterCoursesFailure());
    }
}

export function* getMasterCoursesSaga() {
    yield takeLatest(actions.GET_MASTER_COURSES_REQUEST, getMasterCourses);
}



// WEBPACK FOOTER //
// ./app/containers/master-courses/saga.js